// src/lib/lead/transferLeadOwner.ts — Supabase RPCs for org lead assignment
import { supabase } from "@/lib/supabase";

export type LeadTransferCandidate = {
  user_id: string;
  email: string;
  full_name: string | null;
  display_name: string | null;
};

export async function fetchLeadTransferCandidates(
  organizationId: string
): Promise<{ data: LeadTransferCandidate[] | null; error: string | null }> {
  if (!supabase) return { data: null, error: "Supabase unavailable" };

  const { data, error } = await supabase.rpc("org_list_lead_transfer_candidates", {
    p_org_id: organizationId,
  });

  if (error) {
    return { data: null, error: error.message };
  }

  const rows = Array.isArray(data) ? data : [];
  return {
    data: rows.map((r: Record<string, unknown>) => ({
      user_id: String(r.user_id ?? ""),
      email: String(r.email ?? ""),
      full_name: (r.full_name as string | null) ?? null,
      display_name: (r.display_name as string | null) ?? null,
    })),
    error: null,
  };
}

export async function reassignLeadToOrgMember(args: {
  leadId: string;
  newOwnerUserId: string;
}): Promise<{ ok: true } | { ok: false; error: string }> {
  if (!supabase) return { ok: false, error: "Supabase unavailable" };

  const { error } = await supabase.rpc("reassign_lead_owner", {
    p_lead_id: args.leadId,
    p_new_owner_id: args.newOwnerUserId,
  });

  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
